import {type FunctionalComponent, h} from '@stencil/core';
import type {GuidedApiQuickLink} from '../api';
import {Chips} from './chips';

export interface QuickLinkProps{
    guidedlinkitem: GuidedApiQuickLink,
    clickHandler: CallableFunction,
}

export const QuickLink:FunctionalComponent<QuickLinkProps> = (props) => {
    const link = props.guidedlinkitem;
    const clickHandler = props.clickHandler;
    const isPremium = link._original?.audience === 'Private';

    //TODO: add external link icon
    return <li class="guided-pane__quick-links-section-item guided-pane_item">
      <a
        class="guided-pane__quick-link"
        href={link.openUrl}
        onClick={e => clickHandler(link, e, 'quicklinks')}
        onContextMenu={e => clickHandler(link, e, 'quicklinks')}
      >
        <div class='guided-pane__quick-link-container'>
          {link.quartzIcon ? <div class='guided-pane__quartz-icon-wrapper'>
            <se-icon size='micro'>{link.quartzIcon}</se-icon>
          </div> : ''}
          <p class="guided-pane__quick-link-p">
            {link.chips && link.chips.beforeTitle ? <Chips chips={link.chips.beforeTitle}></Chips> : ''}
            <span class='guided-pane__quick-link-text' innerHTML={link.markup || link.title}/>
            {link.chips && link.chips.afterTitle ? <Chips chips={link.chips.afterTitle}></Chips> : ''}
          </p>
        </div>
      </a>
    </li>;
};
